<template>
  <div class="com-container">
    <div class="map3d-area">
        <img src="../assets/images/ys/china3d.png" width="723" alt="">
    </div>
    <div id="maparea" style="width: 100%; height: 580px"></div>
  </div>
</template>

<script>
import axios from "axios";
import * as echarts from "echarts";
import chinaJson from "./chinaMap.js";
export default {
  data() {
    return {
      img2: require("@/assets/images/ys/map.png"),
      mapName: "china",
      data: [
        { name: "北京", value: 5 },
        { name: "天津", value: 14 },
        { name: "河北", value: 157 },
        { name: "山西", value: 110 },
        { name: "内蒙古", value: 40 },
        { name: "辽宁", value: 40 },
        { name: "吉林", value: 40 },
        { name: "黑龙江", value: 60 },
        { name: "上海", value: 10 },
        { name: "江苏", value: 60 },
        { name: "浙江", value: 50 },
        { name: "安徽", value: 151 },
        { name: "福建", value: 60 },
        { name: "江西", value: 74 },
        { name: "山东", value: 200 },
        { name: "河南", value: 100 },
        { name: "湖北", value: 40 },
        { name: "湖南", value: 50 },
        { name: "重庆", value: 40 },
        { name: "四川", value: 120 },
        { name: "贵州", value: 135 },
        { name: "云南", value: 90 },
        { name: "西藏", value: 25 },
        { name: "陕西", value: 100 },
        { name: "甘肃", value: 60 },
        { name: "青海", value: 20 },
        { name: "宁夏", value: 110 },
        { name: "新疆", value: 32 },
        { name: "广东", value: 10 },
        { name: "广西", value: 100 },
        { name: "海南", value: 40 },
      ],
      toolTipData: [ {
          name: "北京",
          value: 3,
          areas: [],
        },
       
         {
          name: "上海",
          value: 3,
          areas: [],
        },
        {
          name: "天津",
          value: 27,
          areas: [],
        },
        {
          name: "山西",
          value: 5,
          areas: [],
        },
        {
          name: "辽宁",
          value: 80,
          areas: [],
        },
        {
          name: "福建",
          value: 35,
          areas: [],
        },
        {
          name: "河南",
          value: 13,
          areas: [],
        },
         {
          name: "湖南",
          value: 13,
          areas: [],
        },
         {
          name: "江西",
          value: 13,
          areas: [],
        },
         {
          name: "湖北",
          value: 13,
          areas: [],
        }, {
          name: "四川",
          value: 13,
          areas: [],
        }, {
          name: "陕西",
          value: 13,
          areas: [],
        },
      ],
      geoCoordMap: {
        黑龙江: [127.9688, 45.368],
        内蒙古: [110.3467, 41.4899],
        吉林: [125.8154, 44.2584],
        北京市: [116.4551, 40.2539],
        辽宁: [123.1238, 42.1216],
        河北: [114.4995, 38.1006],
        天津: [117.4219, 39.4189],
        山西: [112.3352, 37.9413],
        陕西: [109.1162, 34.2004],
        甘肃: [103.5901, 36.3043],
        宁夏: [106.3586, 38.1775],
        青海: [101.4038, 36.8207],
        新疆: [87.611053, 43.828171],
        西藏: [91.117212, 29.646922],
        四川: [103.9526, 30.7617],
        重庆: [108.384366, 30.439702],
        山东: [117.1582, 36.8701],
        河南: [113.4668, 34.6234],
        江苏: [118.8062, 31.9208],
        安徽: [117.29, 32.0581],
        湖北: [114.3896, 30.6628],
        浙江: [119.5313, 29.8773],
        福建: [119.4543, 25.9222],
        江西: [116.0046, 28.6633],
        湖南: [113.0823, 28.2568],
        贵州: [106.6992, 26.7682],
        云南: [102.9199, 25.4663],
        广东: [113.12244, 23.009505],
        广西: [108.479, 23.1152],
        海南: [110.3893, 19.8516],
        台湾: [120.702967, 24.123621],
        上海: [121.4648, 31.2891],
      },
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      let mapName = this.mapName;
      let toolTipData = this.toolTipData;
      let data = this.data;
      let geoCoordMap = this.geoCoordMap;
      let myChart = echarts.init(document.getElementById("maparea"));
      /*获取地图数据*/
      echarts.registerMap("china", chinaJson.chinaJson);
      let mapFeatures = echarts.getMap(mapName).geoJson.features;
      mapFeatures.forEach(function (v) {
        // 地区名称
        let name = v.properties.name;
        // 地区经纬度
        geoCoordMap[name] = v.properties.cp;
      });
      let option = {
        backgroundColor: "transparent",
        geo: [
          {
            layoutCenter: ["50%", "68%"], //位置
            layoutSize: "180%", //大小
            show: true,
            map: mapName,
            roam: false,
            zoom: 0.65,
            aspectScale: 0.8,
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#1EF9FD",
                },
                formatter: (params) => {
                  if (params.name.includes("省")) {
                    return params.name.slice(0, params.name.length - 1);
                  } else {
                    return params.name;
                  }
                },
              },

              emphasis: {
                show: true,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            regions: [
              {
                name: "甘肃省",
                label: {
                  offset: [40, 40],
                },
              },
               {
                name: "河北省",
                itemStyle: {
                  areaColor: "#1ef9ed",
                },
                label: {
                  color: "#0E2B6D",
                  offset: [-6, 15],
                },
              },
              {
                name: "山东省",
                itemStyle: {
                  areaColor: "#1ef9ed",
                },
                label: {
                  color: "#0E2B6D",
                },
              },
              {
                name: "江苏省",
                itemStyle: {
                  areaColor: "#1ef9ed",
                },
                label: {
                  color: "#0E2B6D",
                },
              },
              {
                name: "安徽省",
                itemStyle: {
                  areaColor: "#1ef9ed",
                },
                label: {
                  color: "#0E2B6D",
                },
              },
              {
                name: "浙江省",
                itemStyle: {
                  areaColor: "#1ef9ed",
                },
                label: {
                  color: "#0E2B6D",
                },
              },
              {
                name: "广东省",
                itemStyle: {
                  areaColor: "#1ef9ed",
                },
                label: {
                  color: "#0E2B6D",
                },
              },
            ],
            itemStyle: {
              normal: {
                // areaColor:'#03396f',
                areaColor:'transparent',
                // color:'#000',
                // areaColor: {
                //   type: "linear",
                //   x: 1200,
                //   y: 0,
                //   x2: 0,
                //   y2: 0,
                //   colorStops: [
                //     {
                //       offset: 0,
                //       color: "rgba(3,51,104,1)", // 0% 处的颜色
                //     },
                //     {
                //       offset: 1,
                //       color: "rgba(3,66,131,1)", // 50% 处的颜色
                //     },
                //   ],
                //   global: true, // 缺省为 false
                // },
                // color: "transparent",

                borderColor: "#3ac9ff",
                borderWidth: 0.5,
                shadowColor: "#3ac9ff",
                // shadowOffsetY: 10,
                shadowBlur: 1,
              },
              emphasis: {
                areaColor: "rgba(0,254,233,0.6)",
                // borderWidth: 0
              },
            },
          },
        //   {
        //     type: "map",
        //     map: mapName,
        //     zlevel: -1,
        //     aspectScale: 0.8,
        //     zoom: 0.65,
        //     layoutCenter: ["50%", "70%"],
        //     layoutSize: "180%",
        //     roam: false,
        //     silent: true,
        //     itemStyle: {
        //       normal: {
        //         borderWidth: 1,
        //         // borderColor:"rgba(17, 149, 216,0.6)",
        //         borderColor: "rgba(58,149,253,0.8)",
        //         shadowColor: "rgba(172, 122, 255,0.5)",
        //         shadowOffsetY: 5,
        //         shadowBlur: 15,
        //         areaColor: "rgba(5,21,35,0.1)",
        //       },
        //     },
        //   },
        //   {
        //     type: "map",
        //     map: mapName,
        //     zlevel: -2,
        //     aspectScale: 0.8,
        //     zoom: 0.65,
        //     layoutCenter: ["50%", "71%"],
        //     layoutSize: "180%",
        //     roam: false,
        //     silent: true,
        //     itemStyle: {
        //       normal: {
        //         borderWidth: 1,
        //         // borderColor: "rgba(57, 132, 188,0.4)",
        //         borderColor: "rgba(58,149,253,0.6)",
        //         shadowColor: "rgba(65, 214, 255,1)",
        //         shadowOffsetY: 5,
        //         shadowBlur: 15,
        //         areaColor: "transpercent",
        //       },
        //     },
        //   },
        //   {
        //     type: "map",
        //     map: mapName,
        //     zlevel: -3,
        //     aspectScale: 0.8,
        //     zoom: 0.65,
        //     layoutCenter: ["50%", "72%"],
        //     layoutSize: "180%",
        //     roam: false,
        //     silent: true,
        //     itemStyle: {
        //       normal: {
        //         borderWidth: 1,
        //         // borderColor: "rgba(11, 43, 97,0.8)",
        //         borderColor: "rgba(58,149,253,0.4)",
        //         shadowColor: "rgba(58,149,253,1)",
        //         shadowOffsetY: 15,
        //         shadowBlur: 10,
        //         areaColor: "transpercent",
        //       },
        //     },
        //   },
        //   {
        //     type: "map",
        //     map: mapName,
        //     zlevel: -4,
        //     aspectScale: 0.8,
        //     zoom: 0.65,
        //     layoutCenter: ["50%", "73%"],
        //     layoutSize: "180%",
        //     roam: false,
        //     silent: true,
        //     itemStyle: {
        //       normal: {
        //         borderWidth: 5,
        //         // borderColor: "rgba(11, 43, 97,0.8)",
        //         borderColor: "rgba(5,9,57,0.8)",
        //         shadowColor: "rgba(29, 111, 165,0.8)",
        //         shadowOffsetY: 15,
        //         shadowBlur: 10,
        //         areaColor: "rgba(5,21,35,0.1)",
        //       },
        //     },
        //   },
        ],
        series: [
          {
            type: "map",
            map: mapName,
            geoIndex: 0,
            zlevel:1,
            aspectScale: 0.8, //长宽比
            zoom: 0.65,
            // showLegendSymbol: true,
            // roam: true,
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#fff",
                  fontSize: "120%",
                },
              },
              emphasis: {
                // show: false,
              },
            },

            itemStyle: {
              normal: {
                areaColor: {
                  type: "linear",
                  x: 1200,
                  y: 0,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(3,27,78,0.75)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(58,149,253,0.75)", // 50% 处的颜色
                    },
                  ],
                  global: true, // 缺省为 false
                },
                borderColor: "#fff",
                borderWidth: 0.2,
              },
            },
            layoutCenter: ["50%", "50%"],
            layoutSize: "180%",
            animation: false,
            markPoint: {
              symbol: "none",
            },
            data: data,
          },
          {
            name: "Top 5",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: this.convertData(toolTipData),
            showEffectOn: "render",
            itemStyle: {
              normal: {
                color: "#00FFFF",
              },
            },
            rippleEffect: {
              scale: 5, // //波纹的扩散范围
              brushType: "stroke",
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "bottom",
                show: false,
                color: "#fff",
                distance: 10,
              },
            },
            symbol: "circle",
            symbolSize: [16, 8], // 波纹中心实心圆的大小
            itemStyle: {
              normal: {
                color: "#16ffff",
                shadowBlur: 10,
                shadowColor: "#16ffff",
              },
              opacity: 1,
            },
            zlevel: 4,
          },
        ],
      };
      myChart.setOption(option);
    },
    convertData(data) {
      let res = [];
      for (let i = 0; i < data.length; i++) {
        let geoCoord = this.geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          });
        }
      }
      return res;
    },
  },
};
</script>

<style lang="less" scoped>
.com-container {
  height: 100%;
  overflow: hidden;
  position: relative;
  .map3d-area {
    position: absolute;
    top: 53px;
    left: 125px;
  }
}
</style>